import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import '../components/styles/Section.css'
import imageSlide from '../data';

const MainSection = () => {

  const[currentState, setCurrentState]= useState(0)
  useEffect(()=>{
    const timer = setTimeout(() => {
      if(currentState===2){
        setCurrentState(0)
      }else{
        setCurrentState(currentState+1)
      }

    }, 5000);
    return ()=> clearTimeout(timer)
  },[currentState])

  const bgImageStyle ={
    backgroundImage: `url(${imageSlide[currentState].url})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    height: '100vh'
  }
  const goToNext = (currentState) => {
    setCurrentState(currentState)
  }

  return (
    <div className='mainsection'>
      <div style={bgImageStyle}>
        <img src="https://bedrocklauncher.github.io/static/media/logo.b56456b0.png" alt="" className='logo' />
        <p>An unofficial Minecraft Bedrock for Windows 10 Launcher</p>
        <div className="btns">
            <a href='https://github.com/BedrockLauncher/BedrockLauncher-Beta/releases/latest/download/build.zip' download className='btn btn-success'>
                Download
            </a>
            <a href="https://github.com/BedrockLauncher/BedrockLauncher" className='btn btn-success'>
              Source
            </a>
            <a href="https://www.paypal.com/donate/?cmd=_donations&business=RNZMRCMNX3SJY&currency_code=USD&source=url" className='btn btn-success'>
              Donate
            </a>
        </div>
        <div className="icons">
          <a href='https://twitter.com/carter5467_99'><i className='fa-brands fa-twitter btn btn-success'></i></a>
          <a href='https://www.youtube.com/channel/UC4-VHCZD7eLdxRr5aUXAQ5w'><i className='fa-brands fa-youtube btn btn-success'></i></a>
          <a href='/#'><i className='fa-brands fa-discord btn btn-success disabled'></i></a>
        </div>
        </div>
        <div className="carousel">
          {
            imageSlide.map((imageSlide,currentState)=>(
              <span key={currentState} onClick={()=> goToNext(currentState)}></span>
            ))
          }
        </div>
    </div>
  )
}

export default MainSection